export class WhatsAppOfficialMensagem {
  public id: number;
  public guidclientenapis: string;
  public whatsapp_oficial_atendimento_id: number;
  public wamid: string;
  public direction: string;
  public message_type: string;
  public from_phone: string;
  public to_phone: string;
  public sender_name: string;
  public texto: string;
  public status_whatsapp: string;
  public meta_status_raw: string;
  public is_internal: boolean;
  public internal_type: string;
  public dt_editada?: Date;
  public dt_deletada?: Date;
  public dt_mensagem: Date;
  public dt_enviado: Date;
  public dt_entregue: Date;
  public dt_lido: Date;
  public dt_falha: Date;
  public payload_json: string;
  public reply_to_message_id: number;
  public reply_to_preview: string;
  public media_url: string;
  public file_name: string;
  public mime_type: string;
  public local_file: File;
  public local_preview_url: string;
  public created_at: Date;
  public updated_at: string;

  constructor() { }
}

// Edicao e exclusao sao persistentes: respostas iniciadas antes da acao nao podem desfaze-las.
export function mesclarEstadoMensagem(local: WhatsAppOfficialMensagem, recebida: WhatsAppOfficialMensagem): WhatsAppOfficialMensagem {
  const result = Object.assign(new WhatsAppOfficialMensagem(), local, recebida);
  if (!local) return result;
  result.dt_deletada = local.dt_deletada || recebida.dt_deletada;
  if ((local.status_whatsapp || '').toLowerCase() === 'deleted') result.status_whatsapp = 'deleted';
  const localEdit = local.dt_editada ? new Date(local.dt_editada).getTime() : 0;
  const receivedEdit = recebida.dt_editada ? new Date(recebida.dt_editada).getTime() : 0;
  if (localEdit > receivedEdit) {
    result.dt_editada = local.dt_editada;
    result.texto = local.texto;
  }
  return result;
}
